(function($) {
 //buidl notification box
 if( typeof Notification !== 'undefined') {
    $.each(Notification, function( index, alert ) {
       var box = $('<div class="alert alert-' + alert.type + ' alert-dismissable">' +
                      '<a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a> ' +
                      alert.message +
                 '</div>');
         box.hide().insertBefore($(alert.selector).filter(":first")).slideDown("slow");
       //add notification above body
       //$(alert.selector).filter(":first").before(box).slideDown(1000);
    });
 }
})(jQuery); // Fully reference jQuery after this point.